/**
 * Quick add from product cards.
 * - Single-variant products: added straight to the cart (hands off to cart.js via rz:cart:add).
 * - Others: a drawer loads the product through the quick-add section (gallery + product blocks).
 */
(() => {
  // Buy buttons in sections load this file too; a second copy must not add a second click handler.
  if (window.rzQuickAdd) return;
  window.rzQuickAdd = true;
  const root = window.Shopify?.routes?.root || '/';
  let drawer;

  const getDrawer = () => {
    if (drawer) return drawer;
    drawer = document.createElement('dialog');
    drawer.className = 'drawer quick-add-drawer';
    drawer.setAttribute('aria-label', window.theme?.strings?.quickAdd || 'Quick add');
    drawer.innerHTML = `<div class="quick-add-drawer__top"><button class="button-plain" type="button" data-dialog-close aria-label="${window.theme?.strings?.close || 'Close'}">✕</button></div><div class="quick-add-drawer__body" data-quick-add-body></div>`;
    document.body.append(drawer);
    // Close after a successful add; the cart drawer (if any) opens instead.
    document.addEventListener('rz:cart:add', () => drawer.open && drawer.close());
    return drawer;
  };

  const ensureProductScript = () =>
    customElements.get('rz-product')
      ? Promise.resolve()
      : new Promise((resolve) => {
          const s = document.createElement('script');
          s.src = window.theme?.assets?.productJs;
          s.onload = resolve;
          document.head.append(s);
        });

  const open = async (button) => {
    button.setAttribute('aria-busy', 'true');
    try {
      const [html] = await Promise.all([
        fetch(`${button.dataset.productUrl}${button.dataset.productUrl.includes('?') ? '&' : '?'}section_id=quick-add`).then((r) => r.text()),
        ensureProductScript(),
      ]);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('.quick-add');
      const d = getDrawer();
      d.querySelector('[data-quick-add-body]').replaceChildren(content);
      d.showModal();
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  const addDirect = async (button) => {
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
      });
      if (!response.ok) return open(button);
      document.dispatchEvent(new CustomEvent('rz:cart:add', { detail: { source: button } }));
      if (!customElements.get('rz-cart')) location.href = `${root}cart`;
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button) return;
    event.preventDefault();
    if (button.dataset.variantId) addDirect(button);
    else open(button);
  });
})();
